import { useState } from "react";
import { HIST_DEFAULT, HistFilterBar, HistStats, HistTable, filterHistory, histTotals } from "../components/History";
import type { HistFilter, HistRow } from "../components/History";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 관측 › 이력의 부품(t-in-port-obs-history) ══
   거르개 줄 · 합계/평균 · 표(값 · 모름 섞임) · 빈 상태. 서버를 안 부른다. */

const ROWS: HistRow[] = [
  { id: "t-in-port-work-projects", title: "프로젝트 화면 포팅", projectId: "in.b3x.app", doneAt: "2026-10-31T01:40:00Z", createdAt: "2026-10-30T13:30:00Z", tokens: 412_000, ms: 41 * 60_000, sessions: 3 }, // copy-ignore: 견본 자료
  { id: "t-in-port-work-repos", title: "리포 거르개", projectId: "in.b3x.app", doneAt: "2026-10-31T01:47:00Z", createdAt: "2026-10-30T13:30:00Z", tokens: null, ms: 12 * 60_000, sessions: 1 }, // copy-ignore: 견본 자료
  { id: "t-ops-1", title: "서버 재구동", projectId: null, doneAt: null, createdAt: "2026-10-29T00:00:00Z", tokens: null, ms: null, sessions: 0 }, // copy-ignore: 견본 자료
];

export function HistoryStates() {
  const [f, setF] = useState<HistFilter>(HIST_DEFAULT);
  const [avg, setAvg] = useState(false);
  const rows = filterHistory(ROWS, f, Date.parse("2026-10-31T03:00:00Z"));
  return (
    <>
      <h3>{tx("pat.hist.bar")}</h3>
      <HistFilterBar value={f} projects={[{ id: "in.b3x.app", name: "b3x-in" }]} avg={avg} onChange={setF} onAvg={setAvg} />
      <HistStats t={histTotals(rows)} avg={avg} />
      <HistTable rows={rows} projectName={(id) => (id === "in.b3x.app" ? "b3x-in" : id ?? "")} shown={50} onMore={() => undefined} />
      <h3>{tx("pat.hist.empty")}</h3>
      <HistStats t={histTotals([])} avg={false} />
      <HistTable rows={[]} projectName={() => ""} shown={50} onMore={() => undefined} />
    </>
  );
}
